<template>
	<div>
		<div>
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">排班管理</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

					<el-row>

						<!-- 左侧组织架构 -->
						<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
							<Structure ref="Structure" @parentFind="find" :condition="condition"></Structure>
						</el-col>

						<!-- 右侧列表 -->
						<el-col :span="20">

							<el-row style="padding-left: 46px; padding-top: 40px;">

								<el-col :span="5">
									<span style="margin-left: 10px;">姓名</span>
									<el-input v-model="condition.staff_name" placeholder="请输入姓名"
										style="width: 70%; margin-left: 10px;"></el-input>
								</el-col>

								<el-col :span="5">
									<span>岗位</span>
									<el-select v-model="condition.post_id" placeholder="全部"
										style="width: 70%; margin-left: 10px;" clearable filterable>
										<el-option v-for="item in postList" :key="item.id" :label="item.post_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-col>

								<el-col :span="6">
									<span>日期</span>
									<el-date-picker v-model="condition.years_date" type="month" placeholder="请选择" value-format="yyyy-MM"
									    style="margin-left: 10px;">
									</el-date-picker>
								</el-col>


								<el-col :span="4">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="find">
										查询</el-button>
								</el-col>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 20px;">
								<el-row>
									<el-col :span="2" v-for="(item , index) in shiftList" :key="item">
										<el-row style="height: 25px;">
											<el-col :span="5">
												<div style="width: 17px; height: 17px; display: inline-block; border-radius: 3px; margin-top: 3px;"
													:style="colorList[index+1]">
												</div>
											</el-col>
											<el-col :span="12">
												<span style="line-height: 25px; display: inline-block;" @click="paiban(item.id)">{{item.shift}}</span>
											</el-col>
										</el-row>
									</el-col>
									<el-col :span="2">
										<el-row style="height: 25px;">
											<el-col :span="5">
												<div style="width: 17px; height: 17px; display: inline-block; border-radius: 3px; margin-top: 3px;"
													:style="colorList[0]">
												</div>
											</el-col>
											<el-col :span="12">
												<span style="line-height: 25px; display: inline-block;" @click="paiban(0)">公休</span>
											</el-col>
										</el-row>
									</el-col>
								</el-row>
								<el-row style="margin-top: 10px;">
									<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										height="530" tooltip-effect="dark" style="width: 100%;"
										@selection-change="handleSelectionChange">
										<el-table-column type="selection" width="55">
										</el-table-column>
										<el-table-column align="center" label="序号">
											<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
										</el-table-column>
										<el-table-column prop="staff_name" align="center" label="姓名">
										</el-table-column>
										<el-table-column prop="post_name" align="center" label="岗位">
										</el-table-column>
										<el-table-column align="center" label="轮休方式">
											<template slot-scope="scope">
												{{'上' + scope.row.holiday_start + '休' + scope.row.holiday_end}}
											</template>
										</el-table-column>
										<el-table-column align="center" v-for="(item, index) in tableTitle" :key="index"
											:label="item.leble" width="70">
											<template slot-scope="scope">
												<el-button :style="colorList[shiftIndex(scope.row, index)]"
													style="color: #FFFFFF; width: 100%; height: 70px;"
													@click="modifyDialog(scope.row, index)">
													{{prop(scope.row, index)}}
												</el-button>
											</template>
										</el-table-column>
									</el-table>
								</el-row>
								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange"
										:page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</el-row>
						</el-col>
					</el-row>
				</div>
			</el-row>
		</div>

		<!-- 弹出层 -->
		<el-dialog title="选择班次" center :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
			<el-radio-group v-model="form.shift_id">
				<el-radio :label="0">公休</el-radio>
				<el-radio v-for="item in shiftList" :key="item.id" :label="item.id">
					{{item.shift}}&nbsp;{{item.start_time_format}}—{{item.end_time_format}}
				</el-radio>
			</el-radio-group>
			<span slot="footer" class="dialog-footer">
				<el-button style="background-color: #FFFFFF; border-color: #006E48; color: #006E48;"
					@click="dialogVisible = false">取 消</el-button>
				<el-button style="background-color: #006E48; border-color: #006E48; color: #FFFFFF;" @click="modify">确 定
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Structure from "../../utils/structure/structure.vue";

	import axios from "axios";
	export default {
		components: {
			Structure: Structure,
		},
		data() {
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				tableTitle: [],

				//全选
				ids: [],

				//条件
				condition: {
					project_id: "",
					post_id: "",
					staff_name: "",
					years_date: this.$globals.getNowTimes()
				},

				//修改数据
				form: {
					id: '',
					index: '',
					staff_id: '',
					shift_id: '',
				},

				//页面相关
				dialogVisible: false,

				//职位下拉
				postList: [],
				//最多班次数
				shiftCount: 0,
				//班次数据
				shiftList: [],

				//颜色数据
				colorList: [{
						backgroundColor: "#4986f8",
					},{
						backgroundColor: "#723fa3",
					}, {
						backgroundColor: "#4f717a",
					}, {
						backgroundColor: "#efba40",
					}, {
						backgroundColor: "#b95f44",
					}, {
						backgroundColor: "#a28a4a",
					}, {
						backgroundColor: "#53b6b7",
					}, {
						backgroundColor: "#8ec222",
					}, {
						backgroundColor: "#019a6c",
					}, {
						backgroundColor: "#ea4150",
					}, {
						backgroundColor: "#f49900",
					}
				]
			};
		},
		methods: {
			// 全选
            handleSelectionChange(e) {
                this.ids = [];
                e.forEach((item) => {
                    this.ids.push(item.id);
                });
            },
			//颜色数据
			shiftIndex(row, index) {
				console.log("颜色数据")
				if (row.scheduling == undefined || row.scheduling == null) {
					return 999;
				}
				if (row.scheduling[this.tableTitle[index].prop] == undefined || row.scheduling[this.tableTitle[index]
						.prop] == null) {
					// if( row.scheduling[this.tableTitle[index].data] == 0) {
						return 999;
					// }
				}
				// console.log(scheduling[this.tableTitle[index].prop])
				if (row.scheduling[this.tableTitle[index].prop] === '公休') {
					return 0;
				}
				var reg = new RegExp("班次", "g");
				var data = row.scheduling[this.tableTitle[index].prop].replace(reg, "");
				return parseInt(data);
			},
			//字体数据
			prop(row, index) {
				// console.log("字体数据")
				if (row.scheduling == undefined || row.scheduling == null) {
					return '无';
				}
				console.log(row.scheduling[this.tableTitle[index].prop])
				if (row.scheduling[this.tableTitle[index].prop] == undefined || row.scheduling[this.tableTitle[index]
						.prop] == null) {
							if( row.scheduling[this.tableTitle[index].data] == 0) {
								return '公休';
							}
							return '无';
				}
				// if (row.scheduling[this.tableTitle[index].prop] == "公休") {
				// 	return '公休';
				// }
				return row.scheduling[this.tableTitle[index].prop];
			},
			//获取表头
			async initializeTableTitle() {
				var tableTitle = await this.$globals.AxiosPost("scheduling/findTableTitle",{
					years_date:this.condition.years_date + '-01',
				} );
				this.tableTitle = tableTitle.data;
			},
			//查询
			async find() {
				this.initializeTableTitle();
				if (this.condition.project_id != null && this.condition.project_id != '') {
					var url = "staff/findStaffScheduling",
						record = {
							page_num: this.page_num,
							page_size: this.page_size,
							project_id: this.condition.project_id,
							post_id: this.condition.post_id,
							staff_name: this.condition.staff_name,
							years_date: this.condition.years_date + '-01'
						};
					var data = await this.$globals.AxiosPost(url, record);
					if (data == '-2000') {
						this.$message.error("服务器未响应！请稍后重试");
					} else {
						var code = data.code;
						var data = data.data;
						if (code == '200') {
							this.total = data.total;
							this.tableData = data.list;
						} else {
							this.$message.warning("请求失败！请稍后重试");
						}
					}
					// this.initializeShiftCount();
					// if(this.shiftList.length <=0 ){
						this.findShift();
					// }
					
					// this.$nextTick(() => {
					//   this.initializeTableTitle();
					//  })
					// this.$forceUpdate();
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val
				this.find();
			},
			//单独修改
			async modifyDialog(row, index) {
				
				console.log(row.scheduling)
				if (row.scheduling == undefined || row.scheduling == null) {
					
					console.log("undefined")
					this.form.shift_id = 0;
					this.form.staff_id = row.id;
				} else {
					this.form.id = row.scheduling.id;
					
					if (row.scheduling[this.tableTitle[index].data] == null || row.scheduling[this.tableTitle[index].data] == 0|| row.scheduling[this.tableTitle[index].data] == 100) {
						this.form.shift_id = 0
					} else {
						this.form.shift_id = row.scheduling[this.tableTitle[index].data]
					}
					
					// this.form.shift_id = row.scheduling[this.tableTitle[index].data] == null ? 100 : parseInt(row
					// 	.scheduling[this.tableTitle[index].data]);
				}
				console.log("form.shift_id="+this.form.shift_id)
				
				this.form.index = index + 1;
				// await this.findShift(row.post_id);

				this.dialogVisible = true;
			},
			//获取班次
			async findShift() {
				var shiftList = await this.$globals.AxiosPost("shift/find", {
					organize_id: this.condition.project_id
				});
				this.shiftList = shiftList.data;
			},
			//单独修改确定
			async modify() {
				console.log("单独修改确定")
				var url = "scheduling/Modify",
					record = {
						id: this.form.id,
						index: this.form.index,
						staff_id: this.form.staff_id,
						shift_id: this.form.shift_id,
						years_date: this.condition.years_date + '-01'
					};
				var data = await this.$globals.AxiosPost(url, record);
				if (data == '-2000') {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code == '200') {
						this.$message.success(data);
						this.qingkong();
						this.find();
						this.dialogVisible = false;
					} else {
						this.$message.warning(data);
					}
				}
			},
			//批量修改
			batchModify(id) {

			},
			//批量排班
			async paiban(shift){
				if(this.ids.length <= 0){
					this.$message.warning("请先选择操作数据！");
                    return false;
				}
				var url = "scheduling/BatchScheduling",
					record = {
							ids:this.ids,
							shift_id: shift,
							years_date: this.condition.years_date + '-01'
					};
				var data = await this.$globals.AxiosPost(url, record);
				if (data == '-2000') {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code == '200') {
						this.$message.success(data);
						this.qingkong();
						this.find();
					} else {
						this.$message.warning(data);
					}
				}

			},

			qingkong(){
				this.ids=[];
				this.form.id='';
				this.form.index='';
				this.form.staff_id='';
				this.form.shift_id='';
			},


			//初始化职位数据
			async initializePost() {
				var postList = await this.$globals.AxiosPost("post/selectFind", {});
				this.postList = postList.data;
			},
			//获取班次数
			// async initializeShiftCount() {
			// 	var shiftCount = await this.$globals.AxiosPost("shift/maxCount", {
			// 		organize_id: this.condition.project_id
			// 	});
			// 	this.shiftCount = shiftCount.data;
			// },
			
		},
		created() {
			this.find();
			this.initializePost();
			this.initializeTableTitle();
		}
	}
</script>

<style scoped="scoped">
	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.el-radio__input.is-checked+.el-radio__label {
		color: #006E48;
	}

	>>>.el-radio__input.is-checked .el-radio__inner {
		border-color: #006E48;
		background: #006E48;
	}
	
	>>>.el-table .cell{
		padding: 0;
	}
	
	>>>.el-table .el-table__cell{
		padding: 0;
	}
	
	>>>.el-table thead{
		height: 40px;
	}
	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// ZnPb.vue?68e0a7eb